import { Component, input, output } from '@angular/core';
import { Subject } from 'rxjs';
import { MediaDetails } from 'src/app/models/media.model';
import {
  OpenDefectInspection,
  OpenDefectInspectionMobile,
} from 'src/app/models/open-defects.model';
import { CoreService } from 'src/app/services/core/core.service';
import { UnroadworthyDefectsService } from 'src/app/services/unroadworthy-defects/unroadworthy-defects.service';

@Component({
  selector: 'app-unrectified-vehicle-details',
  templateUrl: './unrectified-vehicle-details.component.html',
  styleUrls: ['./unrectified-vehicle-details.component.scss'],
  standalone: false,
})
export class UnrectifiedVehicleDetailsComponent {
  /* Indicates whether the component is rendered in mobile context */
  isMobileApp = input<boolean>(false);

  /* Optional card-level CSS class */
  cardClass = '';

  /* Raw unrectified defects list */
  unrectifiedDefects = input<OpenDefectInspection[]>([]);

  /* icnNo of the respective vehicle */
  icnNo = input<string>('');

  /* Emits defect media identifier for preview handling */
  emitDefectMedia = output<string>();

  /**
   *
   */
  constructor(
    private readonly unroadworthyDefectService: UnroadworthyDefectsService,
    private readonly coreService: CoreService,
  ) {
  }

  /* Emits event to open defect-related media */
  // showDefectMedia(id: string): void {
  //   this.emitDefectMedia.emit(id);
  // }
  /**
   * Opens the media modal immediately (with skeleton) then loads the image on mobile
   */
  showDefectMedia(id: string): void {
    const subject = new Subject<MediaDetails>();

    this.coreService.openMediaModalWithLoader(subject.asObservable());

    this.unroadworthyDefectService
      .getDefectMedia(id, this.icnNo())
      .subscribe({
        next: (response) => {
          const mediaDetails = response[0];
          if (!mediaDetails) {
            subject.error(new Error('No media found for this defect'));
            return;
          }
          subject.next(mediaDetails);
          subject.complete();
        },
        error: (err) => {
          subject.error(err);
        }
      });
  }

  /* Determines whether a defect has associated media */
  checkHasMedia(hasMedia: unknown): boolean {
    return hasMedia === true || hasMedia === '1';
  }

  /* Determines whether a defect is marked as safety-related */
  checkSafetyInd(indicator: unknown): boolean {
    return indicator === true || indicator === '1' || indicator == 1;
  }

  /* Grouped defect data structure used for mobile rendering */
  get unrectifiedDefectsMobile(): OpenDefectInspectionMobile[] {
    return this.unroadworthyDefectService.groupUnrectifiedDefects(this.unrectifiedDefects());
  };
}
